import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from 'react-bootstrap';
import {shallowEqual, useSelector} from 'react-redux';
import {useIntl} from 'react-intl';
import {Form, Formik} from 'formik';
import InvoicesList from '../InvoicesList';
import Empty from '../../../../../_common/components/Empty';

const PopupInvoicesList = ({
                             allValues,
                             showPopupInvoicesList,
                             setShowPopupInvoicesList,
                             popupRowIndex,
                             setFieldValue,
                             disabledFields,
                             setDisabledFields
                           }) => {
  const handleCloseModal = () => setShowPopupInvoicesList(false);
  const [additionalDisabledFields, setAdditionalDisabledFields] = useState([]);

  const {currentState} = useSelector((state) => (
      {currentState: state['popupInvoicesList']}),
    shallowEqual
  );
  const {entities, dataLoading} = currentState;
  const invoicesGridData = Boolean(entities) ? entities : [];

  const intl = useIntl();
  const popupHeader = intl.formatMessage({
    id: 'receipts-popup-invoices-list-header',
    defaultMessage: 'Invoices',
  });
  const buttonCancel = intl.formatMessage({
    id: 'invoices-popup-buttonCancel',
    defaultMessage: 'Cancel',
  });
  const buttonSave = intl.formatMessage({
    id: 'invoice-orders-popup-edit-buttonSave',
    defaultMessage: 'Save',
  });

  const initialValuesInvoices = Object.assign({}, ...invoicesGridData.map(item => (
    {
      [`${item._id}`]: false,
      [`closeAmount-${item._id}`]: '',
      [`amount-${item._id}`]: item.amount,
    }
  )));

  const setValuesSingleAgent = (gridValues) => {
    setFieldValue('invoices', getValuesSingleAgent(gridValues));
  };

  const getValuesSingleAgent = (gridValues) => {
    let array = [];
    for (let key in gridValues) {
      if (gridValues[key] === true && !(allValues.invoices.includes({'invoiceID': key}))) {
        array.push({
          'invoiceID': `${key}`,
          'closeAmount': gridValues[`closeAmount-${key}`]
            ? gridValues[`closeAmount-${key}`]
            : gridValues[`amount-${key}`]
        });
      }
    }

    return array;
  };

  const setValuesMultipleAgents = (gridValues) => {
    const {arrayMultiple, selectedKeys} = getValuesForMultipleAgents(gridValues);
    setFieldValue(`lines[${popupRowIndex}].invoices`, arrayMultiple);
    setDisabledFields(prevState => {return [...prevState, selectedKeys];});
  };

  const getValuesForMultipleAgents = gridValues => {
    const arrayMultiple = [];
    const selectedKeys = [];

    for (let key in gridValues) {
      if (
        gridValues[key] === true
        && disabledFields.indexOf(key) === -1
        && !(allValues.lines[popupRowIndex].invoices.includes({'invoiceID': key}))
      ) {
        arrayMultiple.push({
          'invoiceID': `${key}`,
          'closeAmount': gridValues[`closeAmount-${key}`]
            ? gridValues[`closeAmount-${key}`]
            : gridValues[`amount-${key}`]
        });
        selectedKeys.push(key);
      }
    }

    return {arrayMultiple, selectedKeys};
  };

  const setValues = (gridValues) => {
    (allValues.multipleAgents)
      ? setValuesMultipleAgents(gridValues)
      : setValuesSingleAgent(gridValues);
  };

  return (
    <>
      <Formik
        initialValues={initialValuesInvoices}
        onSubmit={() => {
        }}
        enableReinitialize={true}
      >
        {({values, setFieldValue}) => (
          <Form>
            <Modal
              show={showPopupInvoicesList}
              onHide={handleCloseModal}
              className="popup-invoices-list-container"
            >
              <Modal.Body>
                <h3 className="card-title font-weight-bold text-dark text-center mb-10">
                  {popupHeader}
                </h3>
                {(!dataLoading && invoicesGridData.length > 0)
                  ?
                  <InvoicesList
                    invoicesGridData={invoicesGridData}
                    disabledFields={disabledFields}
                    multipleAgents={allValues.multipleAgents}
                    allValues={allValues}
                    setDisabledFields={setDisabledFields}
                    popupRowIndex={popupRowIndex}
                    additionalDisabledFields={additionalDisabledFields}
                    setAdditionalDisabledFields={setAdditionalDisabledFields}
                    setFieldValue={setFieldValue}
                  />
                  :
                  <Empty/>
                }
                <div className="d-flex justify-content-center mt-12">
                  <Button
                    className="btn-secondary btn-sm col-2 mx-3"
                    onClick={handleCloseModal}
                  >
                    {buttonCancel}
                  </Button>
                  <Button
                    className="btn btn-icon btn-sm col-2 mx-3 custom-send-button"
                    onClick={() => {
                      handleCloseModal();
                      setValues(values);
                    }}
                  >
                    {buttonSave}
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
          </Form>
        )}
      </Formik>
    </>
  );
};

PopupInvoicesList.propTypes = {
  data: PropTypes.object,
  allValues: PropTypes.object,
  showPopupInvoicesList: PropTypes.bool,
  setShowPopupInvoicesList: PropTypes.func,
  popupRowIndex: PropTypes.number,
  setFieldValue: PropTypes.func,
  disabledFields: PropTypes.array,
  setDisabledFields: PropTypes.func
};

export default PopupInvoicesList;
